// constants
import { UserActionTypes } from './constants';
import { UserDetailInterface as UserDetailInterfaceDataType } from 'src/types/user';

export type UserActionType = {
    type:
        | UserActionTypes.API_RESPONSE_SUCCESS
        | UserActionTypes.API_RESPONSE_ERROR
        | UserActionTypes.GET_USER
        | UserActionTypes.ADD_USER
        | UserActionTypes.EDIT_USER
        | UserActionTypes.GET_USERS
        | UserActionTypes.GET_USER_BASIC_ROLES
        | UserActionTypes.CAPTURE_USER_HITS
        | UserActionTypes.RESET
        | UserActionTypes.RESET_SUCCESS
        | UserActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const userApiResponseSuccess = (
    actionType: string,
    data: UserDetailInterfaceDataType[] | UserDetailInterfaceDataType | [] | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): UserActionType => ({
    type: UserActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const userApiResponseError = (
    actionType: string,
    data: UserDetailInterfaceDataType[] | UserDetailInterfaceDataType | [] | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): UserActionType => ({
    type: UserActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addUser = (params: any): UserActionType => ({
    type: UserActionTypes.ADD_USER,
    payload: params,
});

export const editUser = (params: any): UserActionType => ({
    type: UserActionTypes.EDIT_USER,
    payload: params,
});

export const getUser = (params: any): UserActionType => ({
    type: UserActionTypes.GET_USER,
    payload: params,
});

export const getUsers = (params: any): UserActionType => ({
    type: UserActionTypes.GET_USERS,
    payload: params,
});

export const getUserBasicRoles = (params: any): UserActionType => ({
    type: UserActionTypes.GET_USER_BASIC_ROLES,
    payload: params,
});

export const getUserHits = (params: any): UserActionType => ({
    type: UserActionTypes.CAPTURE_USER_HITS,
    payload: params,
});

export const resetUser = (): UserActionType => ({
    type: UserActionTypes.RESET,
    payload: {},
});

export const resetUserSuccess = (): UserActionType => ({
    type: UserActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetUserError = (): UserActionType => ({
    type: UserActionTypes.RESET_ERROR,
    payload: {},
});
